import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { AddPaidListMember } from '@/connection/audiences/paid-lists';

export const addPaidListMember = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async ({ paidList, email }: { paidList: string; email: string }) => {
      return await AddPaidListMember(paidList, email);
    },
    {
      fulfilled: (state, action) => {
        if (state.paidListMembers) {
          state.paidListMembers = [action.payload, ...state.paidListMembers];
        }
      },
    }
  );
